export default __webpack_public_path__ + "static/media/Days.acfd97b9.png";